import { CardMedia } from '@mui/material';

const ImageCustom = ({ imageSrc, imageAlt, ...props }) => {
  return <CardMedia component='img' image={imageSrc} alt={imageAlt} {...props} />;
};

export default ImageCustom;
